var _defs, _g, _path, _rect, _path2, _path3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgLives(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 175.496,
    height: 95.816,
    viewBox: "0 0 175.496 95.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:none;}.c{clip-path:url(#b);}.d{fill:#fff;}.e{clip-path:url(#d);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.98,
    y1: 1,
    x2: 0,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff005d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M156.571,0V8.463h-12.1V0H0V95.816H175.5V90.569H109.58V84.978H175.5V0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 175.496,
    height: 95.816
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 175.496,
    height: 95.815,
    transform: "translate(0 0)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M41.165,122.759V57.211h9.455v56.227H65.687v9.321Z",
    transform: "translate(-29.665 -41.23)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 9.455,
    height: 65.548,
    transform: "translate(45.289 15.982)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M251.864,122.759H238.9L232.22,80.4l-3.074-23.186H238.7l6.649,50.514,6.681-50.514h9.555l-3.073,23.252Z",
    transform: "translate(-165.135 -41.23)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M377.853,57.211h24.522v9.321H387.308V85.308H400.27v9.354H387.308v18.776h15.067v9.321H377.853Z",
    transform: "translate(-272.302 -41.229)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M500.606,67.268q0-13.764,13.564-13.764,13.6,0,13.6,13.764v8.82h-9.455v-8.82q0-4.41-4.109-4.443h-.067q-4.077,0-4.076,4.443v5.947q0,4.377,8.853,10.724,8.853,6.314,8.853,15.134v8.286q0,13.8-13.564,13.8-13.6-.034-13.6-13.8v-8.82h9.455v8.82q0,4.444,4.143,4.443,4.109,0,4.109-4.443V99.875q0-4.744-8.853-11.092-8.854-6.315-8.853-15.368Z",
    transform: "translate(-360.764 -38.558)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLives);
export default __webpack_public_path__ + "static/media/img-lives.a9ea4683ca5720fa0d360bfe8db8783e.svg";
export { ForwardRef as ReactComponent };